import { gql } from '@apollo/client';

const NOTIFICATION_FIELDS_FRAGMENT = gql`
  fragment NotificationFields on Notification {
    _id
    userId
    title
    description
    type
    exam {
      _id
      patient {
        _id
      }
    }
    read
    technology
  }
`;

export const GET_USER_NOTIFICATIONS_CONNECTION = gql`
  query GetUserNotificationsConnection(
    $first: Int
    $after: String
    $technology: EnumNotificationTechnology!
  ) {
    userNotificationsConnection(
      first: $first
      after: $after
      technology: $technology
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          ...NotificationFields
        }
      }
    }
  }
  ${NOTIFICATION_FIELDS_FRAGMENT}
`;

export const GET_USER_UNREAD_NOTIFICATIONS_COUNT = gql`
  query GetUserUnreadNotificationsCount(
    $technology: EnumNotificationTechnology!
  ) {
    userUnreadNotificationsCount(technology: $technology)
  }
`;

export const UPDATE_NOTIFICATION = gql`
  mutation UpdateNotification($updateNotificationId: MongoID!) {
    updateNotification(
      filter: { _id: $updateNotificationId }
      record: { read: true }
    ) {
      record {
        _id
        read
      }
    }
  }
`;

export const REMOVE_NOTIFICATION = gql`
  mutation RemoveNotification($notificationId: MongoID!) {
    removeNotification(filter: { _id: $notificationId }) {
      record {
        _id
      }
    }
  }
`;
